export default "__VITE_ASSET__KXoTOZHX__"